import { render, staticRenderFns } from "./SettingsLink.vue?vue&type=template&id=1c4be502&scoped=true&"
import script from "./SettingsLink.vue?vue&type=script&lang=js&"
export * from "./SettingsLink.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SettingsLink.vue?vue&type=style&index=1&id=1c4be502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4be502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
